import { render, staticRenderFns } from "./Benchmarks.vue?vue&type=template&id=538d1c57&"
import script from "./Benchmarks.vue?vue&type=script&lang=js&"
export * from "./Benchmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538d1c57')) {
      api.createRecord('538d1c57', component.options)
    } else {
      api.reload('538d1c57', component.options)
    }
    module.hot.accept("./Benchmarks.vue?vue&type=template&id=538d1c57&", function () {
      api.rerender('538d1c57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/Benchmarks.vue"
export default component.exports